"use client";

import { useState } from "react";
import { Reveal } from "./Reveal";
import { SectionHeader } from "./SectionHeader";
import { Lightbox } from "./Lightbox";
import { PORTRAITS, ROMAN_PORTRAITS } from "@/lib/diwline-data";

export function PortraitsRoyaux() {
  const [idx, setIdx] = useState<number | null>(null);

  return (
    <section id="portraits" className="relative bg-royal py-24 md:py-32" aria-label="Portraits Royaux de Sa Majesté Adjia Daba">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          numero="XIII – XVI"
          titre="Portraits Royaux"
          intro="La Collection DIW'LINE — Sa Majesté Adjia Daba : portrait officiel, visite royale, patriotisme et icône de la Nation."
        />

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {PORTRAITS.map((p, i) => (
            <Reveal key={p.src} delay={i * 0.09}>
              <button
                type="button"
                onClick={() => setIdx(i)}
                className="group relative block w-full overflow-hidden rounded-sm border border-gold/25 focus-visible:outline-gold"
                aria-label={`Agrandir : ${p.titre}`}
              >
                <img
                  src={p.src}
                  alt={p.titre}
                  loading="lazy"
                  className="aspect-[3/4] w-full object-cover transition-transform duration-[1.4s] group-hover:scale-106"
                />
                <span className="absolute inset-0 bg-gradient-to-t from-black/88 via-black/10 to-transparent" />
                <span className="absolute top-4 left-4 rounded-sm bg-black/55 px-2.5 py-1 font-elegant text-xs tracking-[0.3em] text-gold backdrop-blur-sm">
                  {ROMAN_PORTRAITS[i]}
                </span>
                <span className="absolute bottom-0 left-0 right-0 p-5 text-left">
                  <span className="block font-display text-lg font-semibold leading-snug text-gold-light">
                    {p.titre}
                  </span>
                  <span className="mt-2 block text-[12px] leading-relaxed text-cream/70 opacity-0 transition-all duration-300 group-hover:opacity-100">
                    {p.description}
                  </span>
                  <span className="mt-3 block text-[9.5px] uppercase tracking-[0.28em] text-gold/75">
                    Collection DIW&apos;LINE — {p.categorie}
                  </span>
                </span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>

      <Lightbox oeuvre={idx === null ? null : PORTRAITS[idx]} onClose={() => setIdx(null)} onPrev={() => setIdx(c => (c === null ? null : (c - 1 + PORTRAITS.length) % PORTRAITS.length))} onNext={() => setIdx(c => (c === null ? null : (c + 1) % PORTRAITS.length))} />
    </section>
  );
}
